module.exports = __webpack_public_path__ + "img/1728609762959-Screenshot_11-10-2024_92230_www.instagram.com.jpeg.003823e9.webp";